export const buildCoverPromptSuggestionInstruction = (): string =>
	[
		'Based on this page information, output a single sentence (max 20 words) describing an image suitable as a cover image.',
		'The image must visually represent the main topic of the page using relevant symbols, objects, or metaphors.',
		'Do not include human elements unless distant and unrecognizable.',
		'Include a specific visual style and color tone.',
		'Output only the sentence. No preamble. No quotes. No markdown.',
	].join(' ');

export const sanitizeSuggestedPrompt = (raw: string): string => {
	const trimmed = (raw ?? '').trim();
	const unquoted =
		(trimmed.startsWith('"') && trimmed.endsWith('"')) ||
		(trimmed.startsWith("'") && trimmed.endsWith("'"))
			? trimmed.slice(1, -1).trim()
			: trimmed;
	const firstLine = unquoted.split(/\r?\n/)[0]?.trim() ?? '';
	const withoutPrefix = firstLine.replace(/^(prompt|output)\s*:\s*/i, '').trim();

	const words = withoutPrefix.split(/\s+/).filter(Boolean);
	return words.length <= 25 ? withoutPrefix : words.slice(0, 25).join(' ');
};

export const getTargetEditorIdFromDocument = (): string | undefined => {
	// Mirror the EditorTitle pattern: pick the first non-chromeless editor.
	// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
	const proseMirrors = Array.from(document.querySelectorAll<HTMLElement>('.ProseMirror')).filter(
		(el) => !el.closest('[data-testid="chromeless-editor"]') && !el.closest('[data-editor-popup]'),
	);
	return proseMirrors[0]?.dataset?.editorId;
};
